import React from 'react';
import { observable, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';

import { Entry } from '@patient/store/entry/Entry';
import { EntryRelation, entryService } from '@patient/services/entry/entryService';

import { FieldVersionList, FieldVersionListProps } from './FieldVersionList';
import { EntryPage as EntryPageStore } from '@patient/ui/shared/store';
import { translate } from '@chaika/i18n/helper';

interface Props extends FieldVersionListProps {}

interface StoreProps {
    entry: Entry;
    entryPage: EntryPageStore;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    @observable private isLoaded = false;

    public constructor(props: Props & StoreProps) {
        super(props);
        makeObservable(this);
    }

    public async componentDidMount(): Promise<void> {
        await entryService.loadRelations([EntryRelation.Versions]);
        this.isLoaded = true;
    }

    public render(): React.ReactNode {
        const {
            entry,
            entryPage: { rightContentMenu },
        } = this.props;

        const selectedField = rightContentMenu.selectedSubItem || ({} as any);

        const name = selectedField.value;
        let updateTimes: string[] = [];

        if (name) {
            updateTimes = entry.getUniqFieldValuesUpdateTimes(name);
        }

        return this.isLoaded
            ? React.createElement(FieldVersionList, {
                  updateTimes,
                  name,
              })
            : translate('loading');
    }
}

export const FieldVersionListContainer = inject<Props, StoreProps>(Entry.Name, EntryPageStore.Name)(Component);
